<template>
  <v-navigation-drawer
    :value="isOpenTemplateDesignEditor"
    :permanent="isOpenTemplateDesignEditor"
    width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index:13;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        :options="null"
        :loader-save="submitLoading"
        @delete.prevent
        @close="templateUnsaved ? openSaveDialog() : close()"
        @save="submitData({ close: false })"
        button-save
        icon="view_quilt"
      >
        <template v-slot:title>
          <div v-if="translation" class="d-flex align-center">
            <v-icon
              v-text="translation.is_default ? 'star' : 'star_border'"
              :color="translation.is_default ? 'amber darken-2' : ''"
              class="mr-2"
            />
            <v-autocomplete
              v-model="payload.language_code"
              :items="avaliableLanguages"
              :label="$tc('common.language', 1)"
              item-text="name"
              item-value="code"
              hide-details
              solo
              flat
              dense
              background-color="rgba(0,0,0,.2)"
              style="z-index: 20;"
              prepend-inner-icon="translate"
            />
          </div>
        </template>
        <div v-if="template.type === 'pdf' && payload.template" class="d-flex align-center mr-5">
          <v-btn
            ref="button-download-pdf"
            v-if="payload.id"
            :loading="downloadLoading"
            @click="getPDF()"
            color="white"
            text
          >
            Descargar prueba
          </v-btn>
        </div>
        <v-divider vertical />
        <!-- <ImageMenu /> -->
        <v-btn ref="button-menu-images" @click="toggleImageOwner(true)" text>
          <v-icon>image</v-icon>
        </v-btn>
        <v-divider vertical />
        <v-menu
          v-if="!['landing'].includes(template.type)"
          offset-y
          left
          nudge-bottom="10px"
          min-width="300px"
          max-width="300px"
          style="z-index: 20;"
        >
          <template v-slot:activator="{ on }">
            <v-btn ref="button-menu-tags" v-on="on" text>
              <v-icon>code</v-icon>
            </v-btn>
          </template>
          <v-card ref="content-menu-tags">
            <v-card-title>
              {{ $t('templates.create.tags_merge') }}
            </v-card-title>
            <v-divider />
            <v-card-text
              v-if="!mergeTags.array.length"
              style="max-height: 400px; overflow-y: auto;"
              class="pa-4"
            >
              <v-row dense>
                <v-col>
                  <v-img
                    :src="require('@/assets/svg/box_empty.svg')"
                    height="150"
                    max-height="150px"
                    aspect-ratio="1"
                    contain
                  />
                  <div class="text-center">
                    {{ $t('common.no_results_found') }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-list v-else dense max-height="250px" class="overflow-y-auto">
              <v-list-item
                v-for="(item, index) in mergeTags.array"
                :key="index"
                @click="copyText(item.value)"
              >
                <v-icon class="mr-3">
                  bookmark
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title v-if="item.text" v-text="item.text" />
                  <v-list-item-subtitle v-text="item.value" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </BaseToolbar>
      <v-card-text v-if="isOpenTemplateDesignEditor" class="pa-0" style="overflow-y: hidden;height: calc(100vh - 64px)">
        <GrapesJS
          ref="grapesjs-component"
          :type="template.type"
          :template="translation.template || ''"
          :links="links"
          @change="updateTemplate"
        />
      </v-card-text>
    </v-card>
    <input id="copy-text" v-model="copyTextField" type="hidden">
    <iframe
      ref="documentToImage"
      :srcdoc="payload.template.replace('{{headers}}', '').replace('{{scripts}}', '')"
      frameborder="0"
      style="overflow-y:auto; height:auto; width:1080px; position: fixed; top: 0px; left: 100vw;"
    />
    <BaseConfirmDialog
      ref="base-confirm-dialog"
      v-if="saveTemplateDialog.display"
      :accept-text="$t('actions.leave')"
      :cancel-text="$t('actions.cancel')"
      @close="closeSaveDialog()"
      @proceed="close()"
      :title="$t('templates.saveDialog.title')"
      :description="$t('templates.saveDialog.description')"
      :submit-loading="submitLoading"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import config from '@/config'
import BaseToolbar from '@/components/BaseToolbar.vue'
import BaseConfirmDialog from '@/components/BaseConfirmDialog.vue'
// import ImageMenu from '@/components/Images/Menu.vue'
import GrapesJS from '@/components/Templates/GrapesJS/Index'
import templatesMixin from '@/mixins/templates'
import languages from '@/data/languages.json'
import BASE64 from '@/data/base64'
// import domtoimage from 'dom-to-image'
import html2canvas from 'html2canvas'

export default {
  components: {
    BaseToolbar,
    BaseConfirmDialog,
    // ImageMenu,
    GrapesJS
  },
  mixins: [templatesMixin],
  data () {
    return {
      copyTextField: '',
      submitLoading: false,
      downloadLoading: false,
      templateUnsaved: false,
      updateCount: 0,
      saveTemplateDialog: {
        display: false,
        loading: false
      },
      payload: {
        id: null,
        template_id: null,
        language_code: null,
        json_config: null,
        template: '',
        status: 'active',
        is_default: false
      }
    }
  },
  computed: {
    ...mapState({ organizationId: ({ auth: { organizationId } }) => organizationId }),
    ...mapGetters({
      windowSize: 'windowSize',
      images: 'images/images',
      template: 'templates/template',
      translation: 'templates/translation',
      landing: 'landing/landings/landing',
      isOpenTemplateDesignEditor: 'templates/isOpenTemplateDesignEditor',
    }),
    mergeTags () {
      let event
      if (this.template.model_id && this.template.model_type) {
        if (this.template.model_type === 'email_triggers') {
          ({ event } = this.email)
        } else if (this.template.model_type === 'landings') {
          ({ event } = this.landing)
        } else if (this.template.model_type === 'campaigns') {
          event = { variables: ['full_name', 'amount'] }
        }
      } else if (this.template.type === 'thank_you_page') {
        event = { variables: ['full_name', 'amount'] }
      } else {
        ({ event } = this.template)
      }
      const tagsJson = {}
      const tagsArray = []
      if (event) {
        event.variables.forEach(element => {
          tagsJson[element] = {
            name: this.setMergeTag(element),
            value: `{{${element}}}`
          }
          tagsArray.push({
            text: this.setMergeTag(element),
            value: `{{${element}}}`
          })
        })
      }
      return {
        json: tagsJson,
        array: tagsArray
      }
    },
    avaliableLanguages () {
      if (this.translation) {
        return languages.filter(e => !this.template.translations.some(({ language_code }) => language_code === e.code && language_code !== this.translation.language_code))
      }
      return languages
    },
    links () {
      return []
    }
  },
  watch: {
    async isOpenTemplateDesignEditor (newVal) {
      if (newVal) {
        await this.setEditData()
        this.getImages()
      }
    }
  },
  methods: {
    ...mapActions({
      getImages: 'images/getImages',
      saveImage: 'images/saveImage',
      updateTranslation: 'templates/updateTranslation',
      updateTranslationPreview: 'templates/updateTranslationPreview',
      downloadTemplate: 'templates/downloadTemplate'
    }),
    ...mapMutations({
      setTranslation: 'templates/setTranslation',
      closeTemplateDesignEditor: 'templates/closeTemplateDesignEditor',
      toggleImageOwner: 'images/toggleImageOwner'
    }),
    updateTemplate (arg) {
      this.updateCount += 1
      this.payload.template = arg
      if (this.updateCount > 1) {
        this.templateUnsaved = true
      }
      if (this.updateCount > 20) {
        this.submitData({ close: false })
      }
    },
    setEditData () {
      this.payload = {
        ...this.translation,
        template: this.translation.template
          ? this.translation.template
          : ''
      }
    },
    openSaveDialog () {
      this.saveTemplateDialog.display = true
    },
    closeSaveDialog () {
      this.saveTemplateDialog.display = false
    },
    close () {
      this.closeTemplateDesignEditor()
      this.cleanData()
    },
    cleanData () {
      this.setTranslation({})
      this.downloadLoading = false
      this.submitLoading = false
      this.templateUnsaved = false
      this.updateCount = 0
      this.saveTemplateDialog = {
        display: false,
        loading: false
      }
      this.payload = {
        id: null,
        template_id: null,
        language_code: null,
        json_config: null,
        template: '',
        status: 'active',
        is_default: false
      }
    },
    async copyText (text) {
      this.copyTextField = text
      const textToCopy = document.querySelector('#copy-text')
      await textToCopy.setAttribute('type', 'text')
      textToCopy.select()
      try {
        const successful = document.execCommand('copy')
        successful
          ? this.$noty.success(this.$t('images.messages.success.copy'))
          : this.$noty.error(this.$t('images.messages.error.copy'))
      } catch (error) {
        this.$noty.error(this.$t('images.messages.error.copy'))
      }
      this.copyTextField = ''
      textToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    handlerInput (arg) {
      if (!arg) { this.close() }
    },
    async submitData (options) {
      const { close = false } = options
      this.updateCount = 0
      this.payload.template = await this.$refs['grapesjs-component'].getHtml()
      this.submitLoading = true
      const {
        id: translation_id,
        template_id,
        language_code,
        template,
        json_config,
        status
      } = this.payload
      this.getPreviewOffScreen()
      await this.updateTranslation({
        translation_id,
        template_id,
        language_code,
        template,
        json_config,
        status
      })
      if (close) {
        this.close()
      }
      this.templateUnsaved = false
      this.submitLoading = false
    },
    async getPreviewOffScreen () {
      const { id: translation_id, template_id } = this.payload
      const canvas = await html2canvas(this.$refs.documentToImage.contentDocument.body, {
        allowTaint: true,
        useCORS: true,
        scrollX: 0,
        scrollY: 0
      })
      const dataUrl = canvas.toDataURL('image/png')
      this.updateTranslationPreview({
        translation_id,
        template_id,
        preview: dataUrl
      })
    },
    async getPDF () {
      this.downloadLoading = true
      const res = await this.downloadTemplate({
        template_id: this.template.id
      })
      if (res) {
        this.downloadPDF(res)
      }
      this.downloadLoading = false
    },
    downloadPDF (pdf) {
      const url = window.URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = url
      link.download = `${this.template.name}.pdf`
      link.click()
      link.remove()
    },
    setFormCode (id) {
      const url = config.backendURL
      const cryptForm = BASE64.encode(`form-${id}-organization-${this.organizationId}`)
      const code = `<div id="afrus-container-form" data-form="${cryptForm}" data-landing="{{landing_id}}"></div>`
      return code
    }
  }
}
</script>
